import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { twMerge } from 'tailwind-merge'

import { Row } from '../Grid'
import { Text } from '../Text'

const Switch = ({
	isSelected,
	setIsSelected,
	firstOption,
	secondOption,
	boxShadow,
	className,
	...rest
}) => {
	return (
		<Row className={twMerge(className)}>
			<Text variant='small' className='text-gray-700'>
				{firstOption}
			</Text>
			<SwitchComponent
				$isSelected={isSelected}
				$boxShadow={boxShadow}
				onClick={() => setIsSelected(!isSelected)}
				{...rest}
			>
				<Indicator />
			</SwitchComponent>
			<Text variant='small' className='text-gray-700'>
				{secondOption}
			</Text>
		</Row>
	)
}

const SwitchComponent = styled.div`
	display: flex;
	align-items: center;
	width: 43px;
	height: 20px;
	border-radius: 50px;
	justify-content: ${({ $isSelected }) =>
		$isSelected ? 'flex-end' : 'flex-start'};
	padding: 2px;
	margin: 0 8px;
	cursor: pointer;
	background-color: ${({ $isSelected, theme }) =>
		$isSelected
			? (theme?.colors?.orange ?? '#FF7708')
			: (theme?.colors?.gray?.n200 ?? '#F5F5F5')};
	transition: all 0.2s ease-in-out;
	${({ $boxShadow }) => ($boxShadow ? `box-shadow: ${$boxShadow};` : '')}
`

const Indicator = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background: ${({ theme }) => theme?.colors?.white || '#ffffff'};
`

Switch.propTypes = {
	isSelected: PropTypes.bool,
	setIsSelected: PropTypes.func,
	firstOption: PropTypes.string,
	secondOption: PropTypes.string
}

export { Switch }
